import { Tooltip } from '@components/organism/common/Tooltip.jsx'
import { useTooltip } from '@hooks/useTooltip.js'
import { useTranslation } from 'react-i18next'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { Link } from 'react-router-dom'

export const SectionTitle = ({
  title,
  time = '',
  className = '',
  description = false,
  descriptionText = '',
  tooltip = false,
  tooltipKey = '',
  descStyle = '',
  to
}) => {
  const { t } = useTranslation()
  const { activeKey, toggleKey, close } = useTooltip()

  const hasLink = Boolean(to)

  const titleNode = (
    <h2 className="text-navy-900 flex min-w-0 items-center gap-4">
      <span className="text-20 font-bold">{title}</span>
      {hasLink && <MdKeyboardArrowRight size={22} className="shrink-0" />}
    </h2>
  )

  return (
    <div className={className}>
      <div className={'flex items-center justify-between'}>
        <div className={'flex items-center gap-8 leading-none'}>
          {hasLink ? (
            <Link to={to}>{titleNode}</Link>
          ) : (
            <h2 className="text-20 text-navy-900 font-bold">{title}</h2>
          )}

          {tooltip && (
            <Tooltip
              tooltipKey={tooltipKey}
              activeKey={activeKey}
              onToggle={toggleKey}
              onClose={close}
            />
          )}
        </div>
        {time !== '' && (
          <span className="text-14 text-navy-400 shrink-0 whitespace-nowrap">
            {t('common.baseTimeLabel', { time })}
          </span>
        )}
      </div>
      {description && (
        <span className={`text-14 text-navy-400 ${descStyle}`}>{descriptionText}</span>
      )}
    </div>
  )
}
